import { render, staticRenderFns } from "./verhuisservice.vue?vue&type=template&id=730fa9e5"
import script from "./verhuisservice.vue?vue&type=script&lang=js"
export * from "./verhuisservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports